import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './_privacyStyles.css'

export default function WebFooter () {
  const termsLink = 'https://account.underarmour.com/terms-and-conditions'
  const privacyLink = 'https://account.underarmour.com/privacy'
  const contactLink = 'https://support.mapmyfitness.com/hc/requests/new'

  return (
    <div className={styles.webFooterWrapper}>
      <div className={styles.webFooter}>
        <a href={termsLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.terms_of_service'
            defaultMessage='Terms of Service'
          />
        </a>
        <a href={privacyLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.privacy_policy'
            defaultMessage='Privacy Policy'
          />
        </a>
        <a href={contactLink} rel="noopener noreferrer" target='_blank'>
          <FormattedMessage
            id='privacy_center.footer.contact_us'
            defaultMessage='Contact Us'
          />
        </a>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/privacy_center/util/WebFooter.jsx